import { useQuery } from '@tanstack/react-query';
import api from '../../http';

export type PlanCatalogInterval = 'month' | 'year';

export interface PlanCatalogItem {
	_id: string;
	name: string;
	description?: string;
	price: number;
	interval: string;
	intervalCount: number;
	advantages: string[];
	maxProps: number;
	maxSamples: number;
	paymentMethods: string[];
	maxInstallments: number;
	isCurrent: boolean;
	hierarchy?: {
		role?: string | null;
		name?: string | null;
	} | null;
}

export interface PlanCatalogResponse {
	currentPlanId: string | null;
	plans: PlanCatalogItem[];
}

export const useGetPlanCatalog = (interval: PlanCatalogInterval) =>
	useQuery({
		queryKey: ['plan-catalog', interval],
		queryFn: async () => {
			const { data } = await api.get<PlanCatalogResponse>('/plan/catalog', {
				params: { interval },
			});
			return data;
		},
	});
